var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconQuestionCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.793,
    height: 24.793,
    viewBox: "0 0 24.793 24.793",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon-question-circle",
    "data-name": "Icon question-circle",
    d: "M25.355,12.959a12.4,12.4,0,1,1-12.4-12.4A12.4,12.4,0,0,1,25.355,12.959Zm-12.064-8.3A6.474,6.474,0,0,0,7.466,7.848a.6.6,0,0,0,.136.813L9.336,9.976a.6.6,0,0,0,.833-.106c.893-1.133,1.505-1.789,2.864-1.789,1.021,0,2.284.657,2.284,1.647,0,.749-.618,1.133-1.626,1.7-1.176.659-2.732,1.48-2.732,3.532v.2a.6.6,0,0,0,.6.6h2.8a.6.6,0,0,0,.6-.6v-.067c0-1.423,4.158-1.482,4.158-5.332C19.116,6.861,16.109,4.661,13.292,4.661Zm-.333,12.4a2.3,2.3,0,1,0,2.3,2.3A2.3,2.3,0,0,0,12.959,17.058Z",
    transform: "translate(-0.563 -0.563)",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconQuestionCircle);
export default __webpack_public_path__ + "static/media/icon-question-circle.eccd0daaf474777b35e0ddc4308f895c.svg";
export { ForwardRef as ReactComponent };